import { render, staticRenderFns } from "./processSafetyReportDetail.vue?vue&type=template&id=51a30698"
import script from "./processSafetyReportDetail.vue?vue&type=script&lang=js"
export * from "./processSafetyReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a30698')) {
      api.createRecord('51a30698', component.options)
    } else {
      api.reload('51a30698', component.options)
    }
    module.hot.accept("./processSafetyReportDetail.vue?vue&type=template&id=51a30698", function () {
      api.rerender('51a30698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/opm/processSafetyReportDetail.vue"
export default component.exports